module.exports = __webpack_public_path__ + "img/facebook.2dc3ba34.svg";